// "Show content" plays from this pool: the videos of several playlists combined into one.
// content.json holds each video's id and title, copied from YouTube.
import CONTENT_VIDEOS from './content.json';

export const CONTENT = CONTENT_VIDEOS;
